import {
  type ESocialNetwork,
  type ISocialNetworkConfig,
} from '@mahawi/eshop-common/src/types';
import { Switch, Typography } from 'antd';
import { type ColumnsType } from 'antd/es/table';
import React from 'react';

import TableComponent from '../table';

const { Text } = Typography;

const SOCIAL_NETWORK_NAMES: Record<number, string> = {
  1: 'Facebook',
  2: 'Instagram',
};

function SettingsTable({
  configs,
  inProcess,
  onToggle,
}: {
  configs: ISocialNetworkConfig[];
  inProcess: boolean;
  onToggle: (socialNetwork: ESocialNetwork, isEnabled: boolean) => void;
}): React.ReactElement {
  const columns: ColumnsType<ISocialNetworkConfig> = [
    {
      title: 'Social Network',
      dataIndex: 'socialNetwork',
      key: 'socialNetwork',
      render: (val: number): React.ReactElement => (
        <Text strong>{SOCIAL_NETWORK_NAMES[val] ?? `Network #${val}`}</Text>
      ),
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Enabled',
      dataIndex: 'isEnabled',
      key: 'isEnabled',
      render: (
        val: boolean,
        record: ISocialNetworkConfig,
      ): React.ReactElement => (
        <Switch
          checked={val}
          loading={inProcess}
          onChange={(checked: boolean): void =>
            onToggle(record.socialNetwork, checked)
          }
        />
      ),
    },
  ];

  return (
    <TableComponent
      rowKey="id"
      dataSource={configs}
      columns={columns as Parameters<typeof TableComponent>[0]['columns']}
      pagination={false}
      isLoading={inProcess}
    />
  );
}

export default SettingsTable;
